export const Types = {
    authClient: Symbol('AuthClient'),
    userService: Symbol('UserService'),
    authStorage: Symbol('AuthStorage'),
    storageClient: Symbol('StorageClient'),
    toolsService: Symbol('ToolsService'),
    toolsClient: Symbol('ToolsClient'),
    categoryClient: Symbol('CategoryClient')
};
